<template>
  <div class="page-container">
    <!-- <a-tabs :default-active-key="tabKey" @change="handleTabChange">
      <a-tab-pane v-for="item in tabPaneConfig" :key="item.key" :tab="item.tab">
      </a-tab-pane>
    </a-tabs> -->
    <TableList
      :columns="tabPaneConfig[tabKey - 1].columns"
      :tableData="tabPaneConfig[tabKey - 1].tableData"
      :loading="tabPaneConfig[tabKey - 1].loading"
      :scroll="false"
      :pagination="tabPaneConfig[tabKey - 1].pagination"
      @change="handleTableChange"
    >
      <div slot="queryArea" class="query-area">
        <div>
          <!--          <j-dict-select-tag-->
          <!--            style="width: 170px; margin-right: 15px"-->
          <!--            placeholder="请选择年级"-->
          <!--            v-model="queryParam.gradeId"-->
          <!--            identityGet="gradeDict"-->
          <!--            :isShowEmpty="false"-->
          <!--            @select="$set(queryParam, 'classId', undefined)"-->
          <!--          />-->
          <j-dict-select-tag
            style="width: 170px; margin-right: 15px"
            placeholder="请选择班级"
            v-model="queryParam.classId"
            identityGet="classDict"
            :async="true"
            :isShowEmpty="false"
          />
          <a-range-picker v-model="dateRange" class="search-space" style="width: 240px" />
          <j-dict-select-tag
            v-model="queryParam.careList"
            placeholder="关爱等级"
            dictCode="care_list"
            class="search-space"
          />
          <a-input-search
            v-model="queryParam.studentName"
            placeholder="请输入学生名字"
            class="search-space"
            style="width: 200px"
            @change="searchName"
          />
          <a-button type="primary" @click="queryTable">查询</a-button>
        </div>
        <a-button
          type="primary"
          icon="download"
          style="margin-left: auto"
          @click="handleExportXls('关爱学生')"
        >
          导出
        </a-button>
      </div>
      <template slot="action" slot-scope="{ record }">
        <div class="action-detail">
          <span @click="viewTutorRecord(record)">添加关爱记录</span>
          <a-divider type="vertical" />
          <span @click="viewArchives(record)">查看档案</span>
        </div>
      </template>
    </TableList>
    <AddCareRecord ref="addCareRecordRef" @refreshData="loadData" />
  </div>
</template>
<script>
import TableList from '@/components/chart/TableList'
import { getAction } from '@api/manage'
import { simpleDebounce } from '@/utils/util'
import AddCareRecord from './components/AddCareRecord.vue'
import moment from 'moment'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'

const tablePagination = {
  current: 1,
  pageSize: 10,
  pageSizeOptions: ['10', '50', '100'],
  showTotal: (total, range) => {
    return range[0] + '-' + range[1] + ' 共' + total + '条'
  },
  showQuickJumper: true,
  showSizeChanger: true,
  total: 0,
}

export default {
  name: 'CareStudentRecord',
  components: {
    TableList,
    AddCareRecord,
  },
  mixins: [JeecgListMixin],
  data() {
    return {
      tabKey: 1,
      queryParam: {
        // type: 0,
        // name: '',
      },
      dateRange: [],
      tabPaneConfig: [
        {
          tab: '学生咨询',
          key: 1,
          columns: [
            {
              title: '序号',
              dataIndex: 'index',
              align: 'center',
            },
            {
              title: '班级',
              dataIndex: 'studentClass',
              align: 'center',
            },
            {
              title: '学生',
              dataIndex: 'name',
              align: 'center',
            },
            {
              title: '关爱等级',
              dataIndex: 'careList_dictText',
              align: 'center',
            },
            {
              title: '关爱次数',
              dataIndex: 'tutorNum',
              align: 'center',
            },
            {
              title: '家长电话',
              dataIndex: 'phone',
              align: 'center',
              customRender: (_, record) => {
                return record.phone.length >= 25 ? (
                  <a-tooltip>
                    <template slot="title">{record.phone}</template>
                    {record.phone.substring(0, 25) + '...'}
                  </a-tooltip>
                ) : (
                  record.phone
                )
              },
            },
            {
              title: '最近关爱时间',
              dataIndex: 'maxTutorTime',
              align: 'center',
            },
            {
              title: '问题原因',
              dataIndex: 'tagId_dictText',
              align: 'center',
            },
            {
              title: '干预措施',
              dataIndex: 'interventionId_dictText',
              align: 'center',
            },
            {
              title: '效果反馈',
              dataIndex: 'effectFeedback_dictText',
              align: 'center',
              // customRender: (_, record) => {
              //   const res = getDictCodeData('effect_feedback', record.effectFeedback)
              //   return res.text
              // },
            },
            {
              title: '具体情况说明',
              dataIndex: 'comment',
              align: 'center',
            },
            {
              title: '操作',
              dataIndex: 'action',
              align: 'center',
              scopedSlots: { customRender: 'action' },
            },
          ],
          tableData: [],
          loading: false,
          pagination: { ...tablePagination },
        },
      ],
      url: {
        list: '/aigoes/schoolWarnRecord/headteacherCareRecord',
        exportXlsUrl: '/aigoes/schoolWarnRecord/crisisInterventionExport',
      },
      detailModalData: [],
      disableMixinCreated: true,
    }
  },
  created() {
    this.loadData()
  },
  computed: {
    importExcelUrl: function () {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
    },
  },
  methods: {
    handleTabChange(key) {
      this.tabKey = key
      this.queryParam = {}
      this.detailModalData = []
      this.loadData()
    },
    onRangeChange() {},
    // 分页变化
    handleTableChange(page) {
      this.$set(this.tabPaneConfig[this.tabKey - 1], 'pagination', page)
      this.loadData()
    },
    // 查询
    queryTable() {
      console.log('查询条件--', this.queryParam)
      this.$set(this.tabPaneConfig[this.tabKey - 1], 'pagination', { ...tablePagination })
      this.loadData()
    },
    searchName: simpleDebounce(function (event) {
      console.log('搜索条件--', event.target.value)
      const name = event.target.value
      this.getTableData()
    }, 500),
    loadData() {
      switch (this.tabKey) {
        case 1:
          this.$set(this.url, 'list', '/aigoes/schoolWarnRecord/headteacherCareRecord')
          break
      }
      this.getTableData()
      // this.queryParam = {}
    },
    getTableData() {
      this.$set(this.tabPaneConfig[this.tabKey - 1], 'loading', true)
      const params = {
        ...this.queryParam,
        pageNo: this.tabPaneConfig[this.tabKey - 1].pagination.current,
        pageSize: this.tabPaneConfig[this.tabKey - 1].pagination.pageSize,
        beginDate: this.dateRange[0] && moment(this.dateRange[0]).format('YYYY-MM-DD'),
        endDate: this.dateRange[1] && moment(this.dateRange[1]).format('YYYY-MM-DD'),
      }
      getAction(this.url.list, params)
        .then((res) => {
          console.log('获取列表数据--', res)
          if (res.success) {
            const tableData = res.result.records.length
              ? res.result.records.map((item, index) => ({
                  ...item,
                  index: index + 1,
                }))
              : []
            this.$set(this.tabPaneConfig[this.tabKey - 1], 'tableData', tableData)
            this.$set(this.tabPaneConfig[this.tabKey - 1].pagination, 'total', res.result.total)
          }
        })
        .finally(() => {
          this.$set(this.tabPaneConfig[this.tabKey - 1], 'loading', false)
        })
    },
    viewTutorRecord(record) {
      this.$refs.addCareRecordRef.showModal(record)
    },
    viewArchives(record) {
      this.$router.push({
        path: '/school/mentalHealth/ArchivesViewPage',
        query: {
          studentId: record.studentId,
        },
      })
    },
  },
}
</script>
<style scoped lang="less">
.query-area {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}
.action-detail {
  min-width: 100px !important;
  color: #0077fa !important;
  cursor: pointer !important;
}
.search-space {
  width: 140px;
  margin-right: 15px;
}
</style>
